import React, { Component } from "react";
import { Link } from "react-router-dom";

/* REDUX */
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ColetoresActions from "../../store/ducks/coletores";
import ErrorsActions from "../../store/ducks/errors";

/*Styles*/
import { Container, Content, Panel } from "./styles";

/*Layout*/
import { Row, Col } from "react-grid-system";

/*Components*/
import Header from "../../components/Header";
import TopBar from "../../components/TopBar";
import { Button, Form } from "react-bootstrap";
import Loader from "../../components/Loader";

class ColetoreAdd extends Component {
  state = {
    IdColetor: this.props.coletores.currentColetor.IdColetor || "",
    IdCliente: this.props.coletores.currentColetor.IdCliente || "",
    GTag: this.props.coletores.currentColetor.GTag || "",
    IdTipoCol: this.props.coletores.currentColetor.IdTipoCol || "",
    Nome: this.props.coletores.currentColetor.Nome || "",
    NumSerie: this.props.coletores.currentColetor.NumSerie || "",
    Localizacao: this.props.coletores.currentColetor.Localizacao || ""
  };

  componentDidMount() {
    const { id, idColetor } = this.props.match.params;
    const { clearError, getTypes, getColetor } = this.props;
    /* Tipos de Coletores */
    getTypes();
    /* Busca o coletor */
    getColetor(idColetor, id);
    /* Limpa os Erros */
    clearError();
    this.setState({ client_id: id });
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.coletores.currentColetor.IdColetor !==
      this.props.coletores.currentColetor.IdColetor
    ) {
      this.setState({
        IdColetor: this.props.coletores.currentColetor.IdColetor || "",
        IdCliente: this.props.coletores.currentColetor.IdCliente || "",
        GTag: this.props.coletores.currentColetor.GTag || "",
        IdTipoCol: this.props.coletores.currentColetor.IdTipoCol || "",
        Nome: this.props.coletores.currentColetor.Nome || "",
        NumSerie: this.props.coletores.currentColetor.NumSerie || "",
        Localizacao: this.props.coletores.currentColetor.Localizacao || ""
      });
    }
  }

  handleInputChange = e => {
    console.log(e.target.value);
    console.log(e.target.name);
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = e => {
    e.preventDefault();
    const { updateColetor } = this.props;
    updateColetor(this.state);
  };

  render() {
    const { errors, coletores } = this.props;
    const { id } = this.props.match.params;
    console.log(coletores.currentLoaded);
    return (
      <Container>
        {(!coletores.currentLoaded || !coletores.loaded) && <Loader />}
        <Header />
        <Content>
          <TopBar title="Edição de coletor" />
          <Panel>
            <div className="container_action">
              <h1>Editar coletor</h1>
              <Link className="btn btn-success" to={`/projeto/${id}/coletores`}>
                <i className="fa fa fa-arrow-left" /> &nbsp; Voltar
              </Link>
            </div>
            <div className="panel-container">
              <Form>
                <Row>
                  <Form.Group as={Col} xs={12} md={4} lg={4}>
                    <Form.Label>GTag</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Informe a sigla"
                      name="GTag"
                      onChange={this.handleInputChange}
                      value={this.state.GTag}
                    />
                    {errors.data.GTag && (
                      <span className="inputError">{errors.data.GTag}</span>
                    )}
                  </Form.Group>
                  <Form.Group
                    as={Col}
                    xs={12}
                    md={4}
                    lg={4}
                    controlId="formGridName"
                  >
                    <Form.Label>Nome</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Informe o nome do coletor"
                      name="Nome"
                      onChange={this.handleInputChange}
                      value={this.state.Nome}
                    />
                    {errors.data.Nome && (
                      <span className="inputError">{errors.data.Nome}</span>
                    )}
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group
                    as={Col}
                    xs={12}
                    md={6}
                    lg={6}
                    controlId="formGridCnpj"
                  >
                    <Form.Label>Número de série</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Informe o número de série"
                      name="NumSerie"
                      onChange={this.handleInputChange}
                      value={this.state.NumSerie}
                    />
                    {errors.data.NumSerie && (
                      <span className="inputError">{errors.data.NumSerie}</span>
                    )}
                  </Form.Group>

                  <Form.Group
                    as={Col}
                    xs={12}
                    md={6}
                    lg={6}
                    controlId="formGridPassword"
                  >
                    <Form.Label>Tipo de coletor</Form.Label>
                    <Form.Control
                      name="IdTipoCol"
                      as="select"
                      onChange={this.handleInputChange}
                      value={this.state.IdTipoCol}
                    >
                      <option key="0" value="0">
                        Selecione um tipo
                      </option>
                      {coletores.tipos.map(type => (
                        <option key={type.IdTipoCol} value={type.IdTipoCol}>
                          {type.Nome}
                        </option>
                      ))}
                    </Form.Control>
                    {errors.data.IdTipoCol && (
                      <span className="inputError">
                        {errors.data.IdTipoCol}
                      </span>
                    )}
                  </Form.Group>
                </Row>
                <Button
                  variant="primary"
                  type="submit"
                  onClick={this.handleSubmit}
                >
                  Enviar
                </Button>
              </Form>
            </div>
          </Panel>
        </Content>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  projects: state.project,
  errors: state.errors,
  coletores: state.coletores
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ ...ColetoresActions, ...ErrorsActions }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ColetoreAdd);
